import cloneDeep from 'lodash/cloneDeep';

import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: fulfillmentUrl('orders'),

  parse(attributes) {
    return { rawJSON: cloneDeep(attributes), ...attributes };
  },

  addressArray() {
    const destination = this.get('destination');

    return [
      destination.company,
      destination.street1,
      destination.street2,

      [
        destination.city,
        destination.state,
        destination.zip,
      ].join(' '),

      destination.country,
    ].filter(a => !!a);
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_order.js